import { JsonSchema, RankedTester, rankWith, uiTypeIs } from '@jsonforms/core';

export const hasOneOfItems = (schema: JsonSchema): boolean =>
  !!schema?.oneOf?.length &&
  (schema.oneOf as JsonSchema[]).every((entry: JsonSchema) => {
    return entry.const !== undefined;
  });

export const hasEnumItems = (schema: JsonSchema): boolean =>
  schema.type === 'string' && schema.enum !== undefined;

export const groupTester: RankedTester = rankWith(1, uiTypeIs('Group'));
